import { create } from "zustand";

export interface TxStep {
  id: string;
  label: string;
  status: "pending" | "active" | "done" | "error";
}

interface TransactionFlowState {
  isOpen: boolean;
  title: string;
  steps: TxStep[];
  error: string | null;

  open: (title: string, steps: { id: string; label: string }[]) => void;
  close: () => void;
  updateStep: (stepId: string, status: TxStep["status"]) => void;
  setError: (error: string) => void;
}

export const useTransactionFlowStore = create<TransactionFlowState>((set) => ({
  isOpen: false,
  title: "",
  steps: [],
  error: null,

  open: (title, steps) =>
    set({
      isOpen: true,
      title,
      steps: steps.map((s) => ({ ...s, status: "pending" as const })),
      error: null,
    }),

  close: () => set({ isOpen: false }),

  updateStep: (stepId, status) =>
    set((state) => ({
      steps: state.steps.map((s) =>
        s.id === stepId ? { ...s, status } : s,
      ),
    })),

  setError: (error) => set({ error }),
}));
